import { render, staticRenderFns } from "./Typeform.vue?vue&type=template&id=2b5caae5&scoped=true&"
import script from "./Typeform.vue?vue&type=script&lang=ts&"
export * from "./Typeform.vue?vue&type=script&lang=ts&"
import style0 from "./Typeform.vue?vue&type=style&index=0&id=2b5caae5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5caae5",
  null
  
)

export default component.exports